import React from "react";
import { SvgIcon } from "../../../src/index";
var compPaths = {
  s: /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("path", {
    stroke: "currentColor",
    d: "M5 2.5h6A1.5 1.5 0 0112.5 4v9a.5.5 0 01-.853.353L8 9.706l-3.647 3.647a.5.5 0 01-.853-.354V4A1.5 1.5 0 015 2.5z",
    clipRule: "evenodd"
  })),
  m: /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("path", {
    stroke: "currentColor",
    strokeWidth: "1.5",
    d: "M7.5 3.75h9A2.25 2.25 0 0118.75 6v13.499a.75.75 0 01-1.28.53L12 14.559l-5.47 5.47a.75.75 0 01-1.28-.53V6A2.25 2.25 0 017.5 3.75z",
    clipRule: "evenodd"
  })),
  l: /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("path", {
    stroke: "currentColor",
    strokeWidth: "3",
    d: "M15 7.5h18a4.5 4.5 0 014.5 4.5v26.998c0 1.336-1.616 2.004-2.56 1.06L24 29.118l-10.94 10.94c-.944.944-2.56.276-2.56-1.06V12A4.5 4.5 0 0115 7.5z",
    clipRule: "evenodd"
  }))
};
export var Bookmark = /*#__PURE__*/React.memo(function (props) {
  return /*#__PURE__*/React.createElement(SvgIcon, Object.assign({}, props, {
    paths: compPaths,
    fill: "none"
  }));
});